export const APPROVE_RECHARGE_REQUEST = "APPROVE_RECHARGE_REQUEST";
export const APPROVE_RECHARGE_SUCCESS = "APPROVE_RECHARGE_SUCCESS";
export const APPROVE_RECHARGE_FAILURE = "APPROVE_RECHARGE_FAILURE";
export const APPROVE_RECHARGE_RESET = "APPROVE_RECHARGE_RESET";
export const approveRechargeRequest = (payload) => ({
    type: APPROVE_RECHARGE_REQUEST,
    payload,
});
export const approveRechargeSuccess = (payload) => ({
    type: APPROVE_RECHARGE_SUCCESS,
    payload,
});
export const approveRechargeFailure = (payload) => ({
    type: APPROVE_RECHARGE_FAILURE,
    payload,
});
export const approveRechargeReset = () => ({
    type: APPROVE_RECHARGE_RESET,
});
